export default "__VITE_ASSET__CCCkarv6__"